import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-report-widget-devextreme-chart-template',
  templateUrl: './devextreme-chart-template.component.html',
  styleUrls: ['./devextreme-chart-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    class: 'block h-full min-h-0 min-w-0'
  }
})
export class ReportWidgetDevExtremeChartTemplateComponent {
  @Input() chartMetadata: any | null = null;

  get isPieChart(): boolean {
    return this.chartMetadata?.chartKind === 'pie';
  }

  get chartDataSource(): any[] {
    return Array.isArray(this.chartMetadata?.dataSource) ? this.chartMetadata.dataSource : [];
  }

  get chartSeries(): any[] {
    const series = Array.isArray(this.chartMetadata?.series) ? this.chartMetadata.series : [];
    return series.map((item) => {
      if (item?.comparison !== true) {
        return item;
      }

      const labelKey = this.chartMetadata?.comparison?.labelKey || '';
      const fallback = 'Previous period';
      const baseName = item.baseName || item.name || '';
      return {
        ...item,
        name: baseName ? `${baseName} (${labelKey || fallback})` : (labelKey || fallback)
      };
    });
  }

  get chartType(): any {
    return this.chartMetadata?.type || 'bar';
  }

  get chartPalette(): any {
    return this.chartMetadata?.palette || 'Soft Pastel';
  }

  get chartArgumentField(): string {
    return this.chartMetadata?.argumentField || '';
  }

  get chartValueField(): string {
    return this.chartMetadata?.valueField || '';
  }

  get chartRotated(): boolean {
    return this.chartMetadata?.rotated === true;
  }

  get chartLegendVisible(): boolean {
    return this.chartMetadata?.legendVisible !== false;
  }

  get chartLabelsVisible(): boolean {
    return this.chartMetadata?.labelsVisible !== false;
  }
}
